import gql from 'graphql-tag';

/*
*   FeatureFlagInput: {
*       companyId: ID!
*       featureFlagName: String!
*       byUserId: [ID!]
*       byRole: [UserRole!]
*       byDepartmentId: [ID!]
*       bySubCompanyId: [ID!]
*       byUserGroupId: [ID!]
*   }
*/

export const CreateFeatureFlag = gql`
    mutation CreateFeatureFlag($input: FeatureFlagInput!) {
        createFeatureFlag(input: $input) {
            companyId
            featureFlagName
            featureFlagGroups
            byUserId
            byRole
            byDepartmentId
            bySubCompanyId
            byUserGroupId
    }
  }
`;

// Destructive, will delete all existing feature flag groups and create new ones
export const UpdateFeatureFlag = gql`
    mutation UpdateFeatureFlag($input: FeatureFlagInput!) {
        updateFeatureFlag(input: $input) {
            companyId
            featureFlagName
            featureFlagGroups
            byUserId
            byRole
            byDepartmentId
            bySubCompanyId
            byUserGroupId
    }
  }
`;

// Returns a boolean whether the deletion was successful
export const DeleteFeatureFlag = gql`
    mutation DeleteFeatureFlag($companyId: ID!, $featureFlagName: String!) {
        deleteFeatureFlag(companyId: $companyId, featureFlagName: $featureFlagName)
    }
`;

// Non-destructive, will add the group values to the feature flag
export const AddGroupValuesToFeatureFlag = gql`
    mutation AddGroupValuesToFeatureFlag($input: FeatureFlagInput!) {
        addGroupValuesToFeatureFlag(input: $input) {
            companyId
            featureFlagName
            featureFlagGroups
            byUserId
            byRole
            byDepartmentId
            bySubCompanyId
            byUserGroupId
    }
  }
`;

// Non-destructive, will remove the only the group values provided from the feature flag
export const RemoveGroupValuesFromFeatureFlag = gql`
    mutation RemoveGroupValuesFromFeatureFlag($input: FeatureFlagInput!) {
        removeGroupValuesFromFeatureFlag(input: $input) {
            companyId
            featureFlagName
            featureFlagGroups
            byUserId
            byRole
            byDepartmentId
            bySubCompanyId
            byUserGroupId
        }
    }
`;

export const GetFeatureFlag = gql`
    query GetFeatureFlag($companyId: ID!, $featureFlagName: String!) {
        getFeatureFlag(companyId: $companyId, featureFlagName: $featureFlagName) {
            companyId
            featureFlagName
            featureFlagGroups
            byUserId
            byUsers
            byRole
            byDepartmentId
            byDepartments
            bySubCompanyId
            bySubCompanies
            byUserGroupId
            byUserGroups
        }
    }
`;

export const GetFeatureFlagsByCompanyId = gql`
    query GetFeatureFlagsByCompanyId($companyId: ID!, $limit: Int, $nextToken: String) {
        getFeatureFlagsByCompanyId(companyId: $companyId, limit: $limit, nextToken: $nextToken) {
            items {
                companyId
                featureFlagName
                featureFlagGroups
                byUserId
                byRole
                byDepartmentId
                bySubCompanyId
                byUserGroupId
            }
            nextToken
        }
    }
`;
